import React from 'react';
import { Row, Col } from './Grid';
import { colors } from '../config';

const Panel = ({ eyebrow, title, image, icon, items = [], variant }) => (
  <div className="panel">
    <div className="image">
      <img src={image} alt="" />
      <span className="icon">
        {icon ? (
          icon
        ) : (
          <svg width={34} height={27} fill="none">
            <path
              d="M12 .344h10.656c.375 0 .687.135.937.406.271.25.407.552.407.906v6.688h-1.344V1.656H12v24h10.656v-8H24v8c0 .375-.136.698-.407.969-.25.25-.562.375-.937.375H12a1.38 1.38 0 01-.97-.375 1.38 1.38 0 01-.374-.969v-24c0-.354.125-.656.375-.906.27-.27.594-.406.969-.406zm20.656 12H28V7.656a.562.562 0 00-.22-.437.562.562 0 00-.437-.219.688.688 0 00-.5.219.6.6 0 00-.187.437v4.688H22a.636.636 0 00-.47.187.636.636 0 00-.187.469c0 .188.063.344.188.469a.636.636 0 00.469.187h4.656v4.688c0 .166.062.323.187.468a.746.746 0 00.5.188.6.6 0 00.438-.188c.146-.145.219-.302.219-.468v-4.688h4.656a.636.636 0 00.469-.187.592.592 0 00.218-.469.592.592 0 00-.218-.469.636.636 0 00-.47-.187zM1.343 6.188l8-3.75V.968l-8.562 4a1.227 1.227 0 00-.688.75c-.125.355-.114.699.032 1.032L9.343 26.5v-3.156l-8-17.157z"
              fill="#fff"
            />
          </svg>
        )}
      </span>
    </div>

    <div className="panel-body">
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="title">{title}</h2>

      <Row>
        {items.map((item, i) => (
          <Col size={6} key={i}>
            <div className="cell">
              <strong>{item.label}</strong>
              <span>{item.value}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>

    <style jsx>{`
      .panel {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 5px 10px rgba(81, 57, 43, 0.1);
        margin-bottom: 32px;
      }

      .icon {
        position: absolute;
        left: 20px;
        bottom: -22px;
        border-radius: 50%;
        background: linear-gradient(321.15deg, #ff7500 14.67%, #fd9d00 108.47%);
        box-shadow: 0px 12px 24px rgba(237, 113, 0, 0.24);
        width: 60px;
        height: 60px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .panel-body {
        padding: 38px 24px 18px 24px;
      }

      .image {
        position: relative;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      .image img {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 100%;
        height: 150px;
        object-fit: cover;
        object-position: center;
      }

      .eyebrow {
        font-family: ${colors.baseFontDisplay};
        font-weight: 900;
        font-size: 12px;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #89837f;
      }

      .title {
        font-family: ${colors.baseFontDisplay};
        font-weight: 900;
        font-size: 28px;
        margin-top: 0;
        margin-bottom: 14px;
        color: #252220;
        line-height: 1.2;
      }

      .cell > * {
        display: block;
      }

      .cell {
        margin-bottom: 18px;
      }

      .cell span {
        font-size: 18px;
      }
    `}</style>
  </div>
);

export default Panel;
